var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1399 2.13635C16.0919 2.43635 16.0679 2.73635 16.0679 3.03634C16.0679 5.73633 18.2519 7.91912 20.9399 7.91912C21.2399 7.91912 21.5279 7.88432 21.8279 7.83632V17.5191C21.8279 21.5883 19.4279 24.0002 15.3479 24.0002H6.48117C2.39999 24.0002 0 21.5883 0 17.5191V8.64032C0 4.56034 2.39999 2.13635 6.48117 2.13635H16.1399ZM16.3811 9.43231C16.0559 9.39631 15.7331 9.54031 15.5399 9.80431L12.6371 13.5603L9.31195 10.9443C9.10795 10.7883 8.86796 10.7271 8.62796 10.7523C8.38916 10.7883 8.17316 10.9191 8.02796 11.1111L4.47718 15.7323L4.40398 15.8403C4.19998 16.2231 4.29598 16.7151 4.65598 16.9803C4.82398 17.0883 5.00398 17.1603 5.20797 17.1603C5.48517 17.1723 5.74797 17.0271 5.91597 16.8003L8.92796 12.9231L12.3479 15.4923L12.4559 15.5631C12.8399 15.7671 13.3199 15.6723 13.5959 15.3111L17.0639 10.8363L17.0159 10.8603C17.2079 10.5963 17.2439 10.2603 17.1119 9.96031C16.9811 9.66031 16.6919 9.45631 16.3811 9.43231ZM21.108 0C22.704 0 24 1.29599 24 2.89199C24 4.48798 22.704 5.78397 21.108 5.78397C19.512 5.78397 18.216 4.48798 18.216 2.89199C18.216 1.29599 19.512 0 21.108 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoIcon);
export default __webpack_public_path__ + "static/media/SEO-icon.d820e4faf8a706548cb3348709920e8c.svg";
export { ForwardRef as ReactComponent };